export interface UpdateAppVersionParams {
  appId: "com.malayan.MalayanMobile" | "com.malayan.MalayanMobile.TEST";
  platform: "android" | "ios";
  versionCode: number | string;
  versionName: string;
  notes?: string;
  releaseDate?: string | Date;
  updatedByUser: string;
}

export interface PlatformVersionData {
  versionCode: number | string;
  versionName: string;
  releaseDate: string | Date;
  notes: string;
}

export interface VersionData {
  ios: PlatformVersionData;
  android: PlatformVersionData;
  appName: string;
  lastUpdated: string;
}

export interface AppVersionDocument {
  docName: string;
  versionData: VersionData;
}

export interface MobileAppAlertsState {
  appVersions: {
    "com.malayan.MalayanMobile.TEST": AppVersionDocument;
    "com.malayan.MalayanMobile": AppVersionDocument;
  };
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
  message: string | null;
}

export const defaultMobileAppAlertsState: MobileAppAlertsState = {
  appVersions: {
    "com.malayan.MalayanMobile.TEST": {
      docName: "com.malayan.MalayanMobile.TEST",
      versionData: {
        ios: {
          versionCode: "",
          versionName: "",
          releaseDate: "",
          notes: "",
        },
        android: {
          versionCode: "",
          versionName: "",
          releaseDate: "",
          notes: "",
        },
        appName: "",
        lastUpdated: "",
      },
    },
    "com.malayan.MalayanMobile": {
      docName: "com.malayan.MalayanMobile",
      versionData: {
        ios: {
          versionCode: "",
          versionName: "",
          releaseDate: "",
          notes: "",
        },
        android: {
          versionCode: "",
          versionName: "",
          releaseDate: "",
          notes: "",
        },
        appName: "",
        lastUpdated: "",
      },
    },
  },
  status: "idle",
  error: null,
  message: null,
};
